export default __webpack_public_path__ + "static/media/DAIF_Infra_Loop.96ae7d9b.mp4";